// Инициалы для кружка-аватара: первые буквы первых двух слов имени, заглавными
// («Alex Karimov» → «AK»). Имя из одного слова даёт одну букву, пустое — пустую
// строку (кружок тогда без текста). Array.from, а не индекс: так первой «буквой»
// станет целый символ, а не половина суррогатной пары у эмодзи в имени.
export function initials(name: string | null | undefined): string {
  return (name ?? '')
    .trim()
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((word) => Array.from(word)[0].toUpperCase())
    .join('');
}
